import styled from 'styled-components';
import { layout, media } from 'src/components/base';

import { H4Text } from '@prisjakt/ui/text/variants';
import { zindex } from 'src/ui/zindex';

export const Suggestions = styled.div`
  width: 100%;
  max-width: ${layout.pageContent.maxWidth.rem};
  margin: 0 auto;
  position: absolute;
  bottom: -15px;
  z-index: ${zindex.menu.searchSuggestions};
  color: ${p => p.theme.text.primary};

  ${media.smallOnly`
    position: static;
    overflow: auto;
    height: 100vh;
  `};
`;

export const Inner = styled.div`
  position: absolute;
  max-width: ${layout.pageContent.maxWidth.rem};
  width: 100%;

  ${media.smallOnly`
    position: relative;
    padding: ${layout.measurements.spacing050} 0;
    overflow: hidden;
    height: calc(100vh + 200px);
  `}
`;

export const Items = styled.ul`
  margin: 0 auto;
  padding: ${layout.measurements.spacing050} 0 ${layout.measurements.spacing050};
  overflow: hidden;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 4px;
  list-style: none;
  z-index: 1;
  margin-top: -${layout.measurements.spacing050};
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);

  ${media.smallOnly`
    border: none;
    overflow: auto;
    border-radius: none;
    width: 100%;
    min-height: 100%;
    box-shadow: none;
    background: transparent;
  `}
`;

export const PopularSearchesTitle = styled(H4Text)`
  margin-left: ${layout.measurements.spacing100};
  margin-top: ${layout.measurements.spacing100};
  flex: 0 1 auto;
`;

export const AdItem = styled.li``;

export const SuggestionOverlay = styled.div<{ $visible: boolean }>`
  ${p => (!p.$visible ? 'display: none;' : '')}
  position: fixed;
  z-index: ${zindex.menu.searchOverlay};
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;
  background-color: ${p => p.theme.bg.overlay};
  ${media.smallOnly`top: 56px; background-color: ${p => p.theme.colors.base0};`}
`;
